import React from 'react';
import { Route, Switch } from "react-router-dom";
import CheckerReportsModule from "./ca-checker-reports-module/checker-reports-module";

const Checker_Reports = () => {
  return (
    <Switch>
      <Route exact path="/checker_reports">
        <CheckerReportsModule />
      </Route>
    </Switch>
  )
}

export default Checker_Reports;



